export const LS_UPGRADE_PRICING_BANNER_DISABLED = 'upgradePricingBannerDisabled';
export const LS_UTM_PARAMS = 'utmParams';
